// extracted by mini-css-extract-plugin
module.exports = {"tag-dropdown-container":"TagDropDown_tag-dropdown-container__3pN05"};